// Generated by scripts/build-docs-pdf.js. Do not edit.
//
// The documentation PDF's content digest, appended to its link as ?v= so that a rebuild
// reaches readers whose browser is holding an earlier copy.
export const DOCUMENTATION_PDF = "/docs/qms-documentation.pdf?v=3bc06d1c6b36";
